import { useMutation } from '@tanstack/react-query';
import { PERMANENT_COOKIE_NAME } from 'constants/cookies';
import { useState } from 'react';
import {
  type CreateRecurringParams,
  recurringReceivables,
} from 'services/recurringReceivables/recurringReceivables';
import { cookies } from 'utils/cookies/cookies';

export const useCreatePlan = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (planId: string) => void;
  onError?: () => void;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [requestResult, setRequestResult] = useState<
    'success' | 'error' | undefined
  >();
  const [planId, setPlanId] = useState<string | undefined>();

  const { mutate: createPlan } = useMutation({
    mutationKey: ['createPlan'],
    mutationFn: (params: CreateRecurringParams) => {
      const fingerprint = cookies.read(PERMANENT_COOKIE_NAME);
      return recurringReceivables.create({
        ...params,
        fingerprint,
      });
    },
    onMutate: () => setIsLoading(true),
    onSuccess: ({ id: planId }) => {
      setPlanId(planId);
      setRequestResult('success');
      onSuccess?.(planId);
    },
    onError: () => {
      setRequestResult('error');
      onError?.();
    },
    onSettled: () => setIsLoading(false),
  });

  const clearError = () => {
    setRequestResult(undefined);
  };

  return {
    isError: requestResult === 'error',
    isSuccess: requestResult === 'success',
    isLoading,
    planId,
    clearError,
    createPlan,
  };
};
